import { TextField, TextFieldProps } from '@mui/material';
import { Controller } from 'react-hook-form';
import React from 'react';
import UiFormLabel from '../FormLabel/FormLabel';

interface UiInputProps extends Omit<TextFieldProps, 'label'> {
  name: string;
  label?: React.ReactNode;
  control: any;
  rules?: any;
  placeholder?: string;
  defaultValue?: string;
  helperText?: string;
  styles?: {
    label?: React.CSSProperties;
    field?: React.CSSProperties;
  };
}

const UiInput: React.FC<UiInputProps> = ({
  name,
  label,
  control,
  rules,
  placeholder,
  defaultValue = '',
  helperText,
  styles = {}, // default to empty object
  ...rest
}) => {
  // Default styles
  const defaultStyles = {
    label: {
      color: '#2B3942',
      fontSize: '14px',
      display: 'flex',
    },
    field: {
      color: '#2B3942',
      fontSize: '14px',
      padding: '9px 8px 10px 8px',
    },
  };

  const mergedStyles = {
    label: { ...defaultStyles.label, ...styles?.label },
    field: { ...defaultStyles.field, ...styles?.field },
  };

  return (
    <>
      <UiFormLabel>{label}</UiFormLabel>
      <Controller
        name={name}
        control={control}
        rules={rules}
        defaultValue={defaultValue}
        render={({ field, fieldState }) => (
          <TextField
            {...field}
            id={name}
            placeholder={placeholder}
            fullWidth
            error={!!fieldState.error}
            helperText={fieldState.error?.message || helperText}
            sx={{
              '& input': {
                ...mergedStyles.field,
              },
              '& .MuiFormHelperText-root': {
                marginLeft: 0, // Removes the default left margin
              },
            }}
            {...rest}
          />
        )}
      />
    </>
  );
};

export default UiInput;
